export default "__VITE_ASSET__7xUjv$m2__"